import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Accueil from "./Accueil";
import NosAgences from "./NosAgences";
import NosEngagements from "./NosEngagements";
import NotreEntreprise from "./NotreEntreprise";
import NosMarques from "./NosMarques";
import NotFound from "./NotFound";

const Routes = () => {
    const router = createBrowserRouter([
        {
            path: '/',
            element: <Accueil />
        },
        {
            path: '/nosagences',
            element: <NosAgences />
        },
        {
            path: '/nosengagements',
            element: <NosEngagements />
        },
        {
            path: '/nosmarques',
            element: <NosMarques />
        },
        {
            path: '/notrentreprise',
            element: <NotreEntreprise />
        },
        {
            path: '*',
            element: <NotFound />
        }

    ])

    return <RouterProvider router={router} />;
};

export default Routes;